module.exports = __webpack_public_path__ + "img/bg.b574d1df.png";